import { CSSProperties, FC, ReactNode } from 'react';

const ShowInput: FC<{ value?: ReactNode; addonAfter?: ReactNode; children?: React.ReactNode; style?: CSSProperties }> = ({
  value,
  addonAfter,
  children,
  style,
}) => (
  <div style={{ ...style, overflowWrap: 'break-word' }}>
    {value ?? '--'}
    {addonAfter ? <span>&nbsp;{addonAfter}</span> : ''}
    {children}
  </div>
);

export default ShowInput;
